// Converts a Date/ISO string into the local wall-clock value an <input type="datetime-local">
// expects ("YYYY-MM-DDTHH:mm"). Using getters (not toISOString, which renders UTC components)
// keeps the displayed time consistent with what the user actually picked, regardless of the
// server's timezone.
export function toDatetimeLocalValue(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// Parses a naive "YYYY-MM-DDTHH:mm" datetime-local value as browser-local wall-clock time and
// returns an absolute, unambiguous ISO (UTC) timestamp — safe to send to the server regardless
// of what timezone it runs in.
export function fromDatetimeLocalValue(value) {
  if (!value) return null;
  const [datePart, timePart = '00:00'] = value.split('T');
  const [y, m, d] = datePart.split('-').map(Number);
  const [hh, mm] = timePart.split(':').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, hh || 0, mm || 0, 0, 0).toISOString();
}
